// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__4XzOq","input":"Checkbox_input__KAVVD","label":"Checkbox_label__O-SB1","isLoading":"Checkbox_isLoading__N2ryh","spinner":"Checkbox_spinner__HBzEp"};